// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"352":"3023291a","833":"78a150ad","880":"0b086ce9"}[chunkId] + ".chunk.js";
};